import React, { useState } from 'react';
import './PaymentEmail.scss';
import XetEditor from '../../shared/xet-editor/XetEditor';
import { FilterOptionSchema } from '../../../redux/oms/omsTypes';
import Filter from '../Options/Filter/Filter';
import { isNullOrUndefined } from '../../../utils/Helper';

interface PaymentEmailProps {
  hidePaymentEmail: () => void;
}

const PaymentEmail: React.FC<PaymentEmailProps> = ({ hidePaymentEmail }) => {
  const [description, setDescription] = useState('');
  const [emails, setEmai] = useState<FilterOptionSchema[]>([]);
  const [details, setDetails] = useState({});
  const selectId = (name: string, value: any) => {};

  return (
    <div className="p-16 full-width border-box full-height">
      <div className="payment-email-container flex-column gap-16">
        <div className="flex-column ">
          <div className="px-24 py-16 header-email flex-row justify-content-space-between">
            <p className="title">Send Email to Client</p>
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250526142735-x.svg"
              height={20}
              width={20}
              onClick={hidePaymentEmail}
            />
          </div>
          <div className="payment-body-container p-24 flex-column gap-32">
            <div className="input-container flex-row justify-content-space-between align-items-center">
              <p className="key">To</p>
              <Filter
                option={{
                  key: 'to',
                  name: 'To',
                }}
                classname="value"
                optionList={emails}
                multipleSelection={false}
                onSelection={(val, option) => {
                  selectId('to', val);
                }}
                mode="showNames"
                showPlaceholder={false}
                borderStyle="solid"
              />
            </div>
            <div className="input-container flex-row justify-content-space-between align-items-center">
              <p className="key">From</p>
              <Filter
                option={{
                  key: 'from',
                  name: 'From',
                }}
                classname="value"
                optionList={emails}
                multipleSelection={false}
                onSelection={(val, option) => {
                  selectId('to', val);
                }}
                mode="showNames"
                showPlaceholder={false}
                borderStyle="solid"
              />
            </div>
            <div className="input-container flex-row justify-content-space-between align-items-center">
              <p className="key">Cc</p>
              <Filter
                option={{
                  key: 'cc',
                  name: 'Cc',
                }}
                classname="value"
                optionList={emails}
                multipleSelection={false}
                onSelection={(val, option) => {
                  selectId('to', val);
                }}
                mode="showNames"
                showPlaceholder={false}
                borderStyle="solid"
              />
            </div>
            <div className="input-container flex-row justify-content-space-between align-items-center">
              <p className="key">Subject</p>
              <input className="value" />
            </div>
            <div className="separator"></div>
            <XetEditor
              value={description}
              defaultHeight="350px"
              onChange={(description) => setDescription(description)}
            />
          </div>
          <div className="px-24 py-16 header-email flex-row align-items-center gap-32">
            <div className="primary-btn">Send</div>
            <div className="seconary-btn">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentEmail;
